import React, { Component } from 'react';
import './App.css';
import ComponentRow from './panel/ComponentRow';

/*
 * SCR-7835
 * List of input fields that cannot be ordered together
 *
 * -- Metabolomix+ #3200* (901)
 *    -- 5877	Toxic Elements Clearance
 *    -- 5887	Comprehensive Urine Elements
 *
 * -- Metabolomix+ #3200 - UK (904)
 *    -- 5924	Toxic Elements Clearance
 *    -- 5925	Comprehensive Urine Elements
 *
 * -- RMALL-- Metabolomix+ #3200 (928)
 *    -- 6036	Toxic Clearance Elements
 *    -- 6037	Comprehensive Urine Elements
 */
const incompatibleSelectionList = ['5877', '5887', '5924', '5925', '6036', '6037'];

class PanelAddOns extends Component {
	
	constructor(props) {
		super(props);
		
		this.handleCheck = this.handleCheck.bind(this);
	}
	
	handleCheck(e) {
		if( this.props.setDirty ){
			this.props.setDirty(true);
		}
		var selectedAddOns = this.props.selectedAddOns.slice();
		var checkedAddOn = this.props.addOns.find((addOn) => {
			return addOn.id.toString() === e.currentTarget.value;
		});

		// checkedAddOn should always be found. If not, something went wrong...bail.
		if (!checkedAddOn) {
			return;
		}

		let addOnAndChildrenIds = this.getAddOnComponentIds([checkedAddOn]) || [];
		
		if (e.currentTarget.checked) {
			// add the selected addon and its children if checking a box

			// SCR-7835: Do not allow Toxic Elements and Comp Urine add-ons to be ordered together
			selectedAddOns = this.removeIncompatibleSelections(selectedAddOns, checkedAddOn, this.props.addOns);

			// Remove any of the selected ids that are already in the list to prevent duplicates
			selectedAddOns = selectedAddOns.filter((addOnId) => {
				return addOnAndChildrenIds.indexOf(addOnId) === -1;
			});

			// Add the new selections
			selectedAddOns = selectedAddOns.concat(addOnAndChildrenIds);
		} else {
			// otherwise, remove the addon and its children
			selectedAddOns = selectedAddOns.filter((addOnId) => {
				return addOnAndChildrenIds.indexOf(addOnId) === -1;
			});
		}
		
		this.props.setSelectedAddOns(selectedAddOns);
	}

    /**
     * Crawls the addOn list tree to generate an array of addOn component ids.
	 */
    getAddOnComponentIds = (addOnList) => {
    	let componentIds = [];
    	addOnList.forEach(addOnComponent => {
	    	componentIds.push(addOnComponent.id.toString());
	    	if (addOnComponent.addOnList.length) {
	    		componentIds = componentIds.concat(this.getAddOnComponentIds(addOnComponent.addOnList));
	    	}
    	});
    	
    	return componentIds;
	}

	/**
	 * SCR-7835: Do not allow Toxic Elements and Comp Urine add-ons to be ordered together.
	 * Returns the list of selected IDs after removing incompatible components (components that cannot be ordered together).
	 * 
	 * @param selectedAddOnIds The list of InputField IDs that are currently selected
	 * @param selectedAddOn The InputField object that was just selected
	 * @param fullAddOnList The full list of InputField objects rendered by this component
	 * @return The list of selected InputField IDs after removing incompatible items
	 */
	removeIncompatibleSelections = (selectedAddOnIds, selectedAddOn, fullAddOnList) => {
		const selectedId = selectedAddOn.id?.toString();

		/*
		 * Return the original selection list to break out of this method if the newly selected 
		 * item is not in the list of incompatible ids
		 */
		if (!incompatibleSelectionList.includes(selectedId)) {
			return selectedAddOnIds;
		}

		/*
		 * Remove all incompatbile items from the selection list
		 */
		// Shallow copy
		let filteredSelectionList = selectedAddOnIds.slice();

		// If any incompatible item has been selected remove it and all of its children
		for (const incompatibleId of incompatibleSelectionList) {
			if (selectedAddOnIds.includes(incompatibleId)) {
				const incompatibleAddOn = fullAddOnList.find((addOn) => {
					return addOn.id.toString() === incompatibleId;
				});

				if (incompatibleAddOn) {
					const incompatibleChildrenIds = this.getAddOnComponentIds([incompatibleAddOn]);

					filteredSelectionList = filteredSelectionList.filter((addOnId) => {
						return !incompatibleChildrenIds.includes(addOnId.toString());
					});
				}
			}
		}

		return filteredSelectionList;
	}
	
	render() {
		if(this.props.addOns.length > 0) {
			const displayCheckbox = typeof this.props.setSelectedAddOns !== 'undefined';

			let nameColumnWidth = this.props.showCptQuantity ? '6' : '8';
			let cptColumnWidth = this.props.showCptQuantity ? '3' : '3';
			let displayCovidAddon = !this.props.shipToOffice;
			let showHeader = (this.props.showHeader === undefined) || this.props.showHeader;
			return (
				<div>
					{showHeader && (
						<div className="row addons">
							<div className="col-xs-12">
								<span style={{ textDecoration: 'underline black solid 1px' }}>
									<b>Add-Ons</b>
								</span>
							</div>
						</div>
					)}
					<div className="addons">
						{this.props.addOns
							.filter((listValue) => (displayCovidAddon || listValue.name.indexOf('SARS') < 0))
							.map((listValue) => {
								let checked = this.props.selectedAddOns.indexOf(listValue.id.toString()) !== -1;
								let parentChecked = this.props.parentSelected || false;
								// SCR-7835: Do not allow Toxic Elements and Comp Urine add-ons to be ordered together
								const toxicElements = listValue.id === 5877 || listValue.id === 5924 || listValue.id === 6036;
								return (
										<div key={listValue.id}>
										{toxicElements && (
											<div className="small text-danger">
												Please choose between the Toxic Elements Clearance or the Comprehensive Urine Elements.
												Toxic Elements Clearance is included in the Comprehensive Urine Elements so both cannot be selected.
											</div>
										)}
									<ComponentRow
										inputFieldType="addOn"
										nameColumnWidth={nameColumnWidth}
										cptColumnWidth={cptColumnWidth}
										displayCheckbox={displayCheckbox}
										inputField={listValue}
										disabled={this.props.disabled}
										checked={(checked || parentChecked)}
										handleCheck={this.handleCheck}
										isMedicareOrder={this.props.isMedicareOrder}
										parentChecked={parentChecked}
										showCptQuantity={this.props.showCptQuantity}
										cptQuantityMap={this.props.cptQuantityMap}
										splitCptQty={this.props.splitCptQty}
										disableCptQtyUpdate={this.props.disableCptQtyUpdate}
										isEditingCptQuantity={this.props.isEditingCptQuantity}
										updateCptQuantity={this.props.updateCptQuantity}
										priceMap={this.props.priceMap}
										priceDisplayType={this.props.priceDisplayType}
									/>
									<PanelAddOns
										addOns={listValue.addOnList}
										step={this.props.step}
										setDirty={this.props.setDirty}
										disabled={this.props.disabled}
										selectedAddOns={this.props.selectedAddOns}
										setSelectedAddOns={this.props.setSelectedAddOns}
										showCptQuantity={this.props.showCptQuantity}
										splitCptQty={this.props.splitCptQty}
										shipToOffice={this.props.shipToOffice}
										showHeader={false}
										parentSelected={checked}
										isMedicareOrder={this.props.isMedicareOrder}
										cptQuantityMap={this.props.cptQuantityMap}
										updateCptQuantity={this.props.updateCptQuantity}
										isEditingCptQuantity={this.props.isEditingCptQuantity}
										disableCptQtyUpdate={this.props.disabled}
									/>
									</div>
								)
							})
						}
					</div>
				</div>
			)
		}
		return null;
	}
}

export default PanelAddOns;
